import {BsTwitter} from "react-icons/bs";
import {FaLinkedin, FaGithub} from "react-icons/fa";
import {SiLinktree} from "react-icons/si";

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a
        href="https://linktr.ee/rohitroy_r"
        target="_blank"
        rel="noopener noreferrer"
      >
        <SiLinktree />
      </a>
    </div>
    <div>
      <a
        href="https://github.com/rohitroy-github"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaGithub />
      </a>
    </div>
    <div>
      <a
        href="https://twitter.com/rohitroy_R"
        target="_blank"
        rel="noopener noreferrer"
      >
        <BsTwitter />
      </a>
    </div>
    <div>
      <a
        href="https://www.linkedin.com/in/roy-rohit/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaLinkedin />
      </a>
    </div>
  </div>
);

export default SocialMedia;
